module.exports = __webpack_public_path__ + "static/media/USDCe.3b5972c1.svg";